import "../../../assets/css/font.css.ts.vanilla.mjs";
import "./ReoButton.css.ts.vanilla.mjs";
var n = { longBarColor: "var(--p273__buttonTemplate-3827_fc841b441__ghostLoadingBar-longBarColor__1ktz88sn)", shortBarColor: "var(--p273__buttonTemplate-3827_fc841b441__ghostLoadingBar-shortBarColor__1ktz88so)" }, t = "p273__ReoButton-612a_fc9c85940__rqn1dnj", r = "p273__ReoButton-612a_fc9c85940__rqn1dn8", a = "p273__ReoButton-612a_fc9c85940__rqn1dna", e = "p273__ReoButton-612a_fc9c85940__rqn1dn4", c = "p273__ReoButton-612a_fc9c85940__rqn1dn5", B = "p273__ReoButton-612a_fc9c85940__rqn1dnb", u = "p273__ReoButton-612a_fc9c85940__rqn1dn7", d = { large: "p273__ReoButton-612a_fc9c85940__rqn1dnc", medium: "p273__ReoButton-612a_fc9c85940__rqn1dnd", small: "p273__ReoButton-612a_fc9c85940__rqn1dne" }, p = "p273__ReoButton-612a_fc9c85940__rqn1dn6", f = "p273__ReoButton-612a_fc9c85940__rqn1dn3", q = { large: "p273__ReoButton-612a_fc9c85940__rqn1dng p273__ReoButton-612a_fc9c85940__rqn1dnf", medium: "p273__ReoButton-612a_fc9c85940__rqn1dnh p273__ReoButton-612a_fc9c85940__rqn1dnf", small: "p273__ReoButton-612a_fc9c85940__rqn1dni p273__ReoButton-612a_fc9c85940__rqn1dnf" }, R = { large: "p273__ReoButton-612a_fc9c85940__rqn1dn0", medium: "p273__ReoButton-612a_fc9c85940__rqn1dn1", small: "p273__ReoButton-612a_fc9c85940__rqn1dn2" }, l = "p273__ReoButton-612a_fc9c85940__rqn1dn9";
export {
  n as ghostLoadingBar,
  t as loadingWrap,
  r as reoButton,
  a as reoButtonContent,
  e as reoButtonDisabled,
  c as reoButtonGhost,
  B as reoButtonIcon,
  u as reoButtonIconLeft,
  d as reoButtonIconSize,
  p as reoButtonLoading,
  f as reoButtonNormal,
  q as reoButtonOnlyIconSize,
  R as reoButtonSize,
  l as reoButtonWrap
};
//# sourceMappingURL=ReoButton.mjs.map
